import GaugeWithNeedle from '../../../../../../../components/Charts/GaugeNeedle/GaugeWithNeedle'



export default function GetBloodGauge() {

  return (

      <GaugeWithNeedle realAge={54} chronologicalAge={62} />
    
  );
};




